
/**
 *	configurator:
 *
 *	Allgemeine states, die von verschiedenen components / views
 *	benötigt werden.
 *
 * 	Beispiel zum Ändern eines globalen Wertes von einer Komponente aus:
 * 	this.$store.commit('configurator/SET', obj);
 *
 * 	Zugriff auf Wert aus Komponente:
 * 	this.$store.state.configurator
 *
 * 	Alternativ mapState() verwenden:
 * 	import { mapState } from 'vuex';
 * 	computed: {
 * 		...mapState('configurator', ['configurator']),
 * 	}
 * 	Zugriff: this.configurator...
 *
 */

export const state = {
	intro: {},
	preselect: {},
	selects: {},
	configurator: {},
	kombis: [],
	komponenten: {},
}


export const mutations = {

	/**
	 *  Attribute der App global setzen, z.B. Angaben über
	 *  den sichtbaren Viewport, die Fensterbreite etc.
	 *  Wird vorallem im CSS verwendet, um per CSS-Variablen die
	 *  Größe von Elementen zu berechnen.
	 */
	SET(state, data) {
		state.configurator = Object.assign( state.configurator, data );
		if (data.kombis) {
			this.commit('configurator/SET_KOMBIS', data.kombis);
		}
		if (data.komponenten) {
			this.commit('configurator/SET_KOMPONENTEN', data.komponenten);
		}
	},
	SET_INTRO(state, data) {
		state.intro = data;
	},
	SET_SELECTS(state, data) {
		state.selects = data;
	},
	SET_PRESELECT(state, data) {
		state.preselect = data;
	},
	SET_KOMPONENTEN(state, data) {
		state.komponenten = data;
	},
	SET_KOMBIS(state, data) {
		state.kombis = data;
	},
	ADD_KOMPONENTE(state, data) {
		for (var i in data) {
			state.komponenten[i] = data[i];
		}
	},
	ADD_KOMBI(state, data) {
		state.kombis.push( data );
	},
}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/configurator.js